"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewClubMigrationModal = void 0;
var newClubMigrationModal_1 = require("./newClubMigrationModal");
Object.defineProperty(exports, "NewClubMigrationModal", { enumerable: true, get: function () { return __importDefault(newClubMigrationModal_1).default; } });
